import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { format, parseISO } from "date-fns";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Cacheable } from "ts-cacheable";

import { environment } from "@environments/environment";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { ParamsService } from "@shared/Services/params.service";

import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";

import { InsuranceReceiptEmailRequest } from "../Types/Interfaces/payment-receipt-email.interface";
import { PaymentReceiptFilter } from "../Types/Interfaces/payment-receipt-filter.interface";
import { PaymentReceipt } from "../Types/Interfaces/payment-receipt.interface";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class PaymentReceiptRepository {
  constructor(private http: HttpClient, private paramsService: ParamsService) {}

  public getPaymentReceipts(paymentReceiptFilter: PaymentReceiptFilter): Observable<PaymentReceipt[]> {
    const params = this.paramsService.mapRequestParams(paymentReceiptFilter);
    return this.http.get<PaymentReceipt[]>(`${enlineaBackendUrl}/api/seguros/PaymentReceipt/GetFacturasRecibos`, { params }).pipe(
      map((paymentReceipts) => {
        return paymentReceipts.map((receipt) => {
          return {
            ...receipt,
            emissionDate: format(parseISO(receipt.emissionDate), "dd/MM/yyyy"),
            policy: { ...receipt.policy, policy: `${receipt.policy?.productCode}-${receipt.policy?.policyNumber}` },
            contractor: {
              ...receipt.contractor,
              fullName: `${receipt.contractor?.name} ${
                receipt.contractor?.lastName !== receipt.contractor?.name ? receipt.contractor?.lastName : ""
              }`,
            },
          };
        });
      })
    );
  }

  @Cacheable()
  public getPaymentReceiptTypes(): Observable<DropdownOption[]> {
    return this.http.get<DropdownOption[]>(`${enlineaBackendUrl}/api/seguros/PaymentReceipt/ReceiptTypes?spinner=false`);
  }

  public getPaymentReceiptReport(receiptNumber: string): Observable<Blob> {
    return this.http.get(`${enlineaBackendUrl}/api/seguros/PaymentReceipt/Report/${receiptNumber || ""}`, {
      responseType: "blob",
    });
  }

  public sendPaymentReceiptEmail(paymentReceiptRequest: InsuranceReceiptEmailRequest): Observable<ShareMessageResponse> {
    return this.http.post<ShareMessageResponse>(`${enlineaBackendUrl}/api/insurance/receipt/email`, paymentReceiptRequest);
  }
}
